import { Component } from "@angular/core";
import { UserService } from "../shared/services/user.service";
import "rxjs/add/operator/map";
import { Router } from "@angular/router";
import { MarvelChampionsConfiguration } from "./marvel-champions-configuration.model";

@Component({
  selector: "app-marvel-champions",
  templateUrl: "./marvel-champions.component.html",
  styleUrls: ["./marvel-champions.component.scss"]
})
export class MarvelChampionsComponent {
  user;
  marvelChampionsConfigurationHomePage = MarvelChampionsConfiguration.homePage;

  constructor(private userService: UserService, private router: Router) {
    this.userService.auth.user.subscribe(user => {
      this.user = user;
    });
  }

  _login(e) {
    this.userService.login(e);
  }

  _logout() {
    this.userService.logout();
  }

  navigateToRooms() {
    this.router.navigate(["/mc/room"]);
  }
}
